module.exports = __webpack_public_path__ + "static/img/gywm_gsjj_img_two.9bf3ea0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gywm_gsjj_img_two.png
// module id = uYws
// module chunks = 21